var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverThird(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 16.7627L16.0001 26.6667L6.00012 16.7627C5.34052 16.1208 4.82097 15.3493 4.47418 14.4968C4.12739 13.6443 3.96087 12.7293 3.9851 11.8092C4.00933 10.8892 4.2238 9.98417 4.61499 9.15111C5.00619 8.31804 5.56563 7.575 6.2581 6.96876C6.95057 6.36253 7.76106 5.90624 8.63853 5.62863C9.51601 5.35102 10.4415 5.2581 11.3566 5.35573C12.2718 5.45335 13.1568 5.7394 13.956 6.19587C14.7551 6.65233 15.4511 7.26933 16.0001 8.00799C16.5515 7.27469 17.2483 6.66309 18.0469 6.21146C18.8455 5.75984 19.7288 5.47792 20.6414 5.38335C21.5539 5.28878 22.4762 5.38359 23.3505 5.66185C24.2247 5.94011 25.0322 6.39582 25.7222 7.00048C26.4122 7.60513 26.97 8.3457 27.3607 9.17585C27.7513 10.006 27.9664 10.9078 27.9925 11.8249C28.0186 12.742 27.8551 13.6546 27.5123 14.5057C27.1695 15.3567 26.6547 16.1278 26.0001 16.7707",
    stroke: "#1E3240",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverThird);
export default __webpack_public_path__ + "static/media/discover-third.eca0c1f2c28722a62725465dee61ae78.svg";
export { ForwardRef as ReactComponent };